import { jsx as _jsx } from "react/jsx-runtime";
import { AppRouter } from "@/routes/AppRouter";
export var App = function () {
    return _jsx(AppRouter, {});
};
